import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

export function AntiGravityBackground() {
    // Generate random particles
    const particles = useMemo(() => {
        return Array.from({ length: 15 }).map((_, i) => ({
            id: i,
            size: Math.random() * 60 + 20, // 20px - 80px
            x: Math.random() * 100, // 0% - 100%
            y: Math.random() * 100, // 0% - 100%
            duration: Math.random() * 10 + 10, // 10s - 20s
            delay: Math.random() * 5,
        }));
    }, []);

    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute inset-0 bg-gradient-to-br from-white via-sky-50 to-fuchsia-50 opacity-60 mix-blend-multiply" />

            {particles.map((p) => (
                <FloatingParticle key={p.id} {...p} />
            ))}

            {/* Glass overlay for texture */}
            <div className="absolute inset-0 backdrop-blur-[1px]" />
        </div>
    );
}

function FloatingParticle({ size, x, y, duration, delay }) {
    return (
        <motion.div
            className="absolute rounded-full bg-white/40 backdrop-blur-md"
            style={{
                width: size,
                height: size,
                left: `${x}%`,
                top: `${y}%`,
            }}
            animate={{
                y: [0, -40, 0],
                x: [0, 20, 0],
                opacity: [0.3, 0.6, 0.3],
                scale: [1, 1.1, 1],
            }}
            transition={{
                duration: duration,
                repeat: Infinity,
                ease: "easeInOut",
                delay: delay,
            }}
        />
    );
}
